<div class="pack-discount d-flex flex-md-column align-items-md-center position-relative" (click)="checked(true)" [ngClass]="{
    selected: isSelected,
    'pack-suggested-easy': isLast && pack.type==1, 'pack-suggested-smart': isLast && pack.type==2, 'pack-suggested-full': isLast && pack.type==3,
    'hover-easy': pack.type==1,'hover-smart': pack.type==2, 'hover-full': pack.type==3
}" >
    <div *ngIf="isLast" class="suggestion">
        <div class="content" [ngClass]="{ 'background-color-easy': pack.type==1,'background-color-smart': pack.type==2, 'background-color-full': pack.type==3 }">
        <p class="text mx-3">{{"pt.edp.edponline.pack.suggestion" | translate}}</p>
        </div>
    </div>
    <div class="discount-card">
        <div class="discount-card-header">
            <div class="discounts" *ngIf="discount.contractType === 'dual' && discount.values.electricity === discount.values.gas; else regularDiscounts">

                <span class="title-discount-value" [ngClass]="{'color-easy': pack.type==1,'color-smart': pack.type==2, 'color-full': pack.type==3 }">{{ discount.values.electricity }}<span
                        class="title-discount-value-sign" [ngClass]="{'color-easy': pack.type==1,'color-smart': pack.type==2, 'color-full': pack.type==3 }">%</span></span>

                <span class="title" [innerHTML]="'pt.edp.edponline.pack.discount.bothAnd' | translate" [ngClass]="{'color-easy': pack.type==1,'color-smart': pack.type==2, 'color-full': pack.type==3 }"></span>
            </div>

            <ng-template #regularDiscounts>

                <div class="discounts" *ngIf="discount.contractType !== 'gas'">

                    <span class="title-discount-value" [ngClass]="{'color-easy': pack.type==1,'color-smart': pack.type==2, 'color-full': pack.type==3 }">{{ discount.values.electricity }}<span
                            class="title-discount-value-sign" [ngClass]="{'color-easy': pack.type==1,'color-smart': pack.type==2, 'color-full': pack.type==3 }">%</span></span>

                    <span class="title" [innerHTML]="'pt.edp.edponline.pack.discount.electricity' | translate" [ngClass]="{'color-easy': pack.type==1,'color-smart': pack.type==2, 'color-full': pack.type==3 }"></span>
                </div>

                <div class="discounts" *ngIf="discount.contractType !== 'electricity' && discount.values.electricity !== discount.values.gas">

                    <span class="title-discount-value" [ngClass]="{'color-easy': pack.type==1,'color-smart': pack.type==2, 'color-full': pack.type==3 }">{{ discount.values.gas }}<span
                            class="title-discount-value-sign" [ngClass]="{'color-easy': pack.type==1,'color-smart': pack.type==2, 'color-full': pack.type==3 }">%</span></span>

                    <span *ngIf="discount.values.electricity !== discount.values.gas" class="title" [innerHTML]="'pt.edp.edponline.pack.discount.gas' | translate" [ngClass]="{'color-easy': pack.type==1,'color-smart': pack.type==2, 'color-full': pack.type==3 }"></span>
                    <span *ngIf="discount.values.electricity == discount.values.gas" class="title" [ngClass]="{'color-easy': pack.type==1,'color-smart': pack.type==2, 'color-full': pack.type==3 }">{{ 'pt.edp.edponline.pack.discount.electricity' | translate }} {{ 'pt.edp.edponline.pack.discount.subtitle-part-3' | translate }} {{ 'pt.edp.edponline.pack.discount.gas' | translate }}</span>
                </div>
            </ng-template>
        </div>
        <div class="card-footer">
            <span class="card-footer-text">{{ discount.title | uppercase }}</span>
        </div>
    </div>
</div>